import { __generator } from "tslib";
import { takeEvery, all, put, select } from 'redux-saga/effects';
import { collectFave } from '../../../CollectionPanel/redux/actionCreators';
import { getFeedNotificationQueue, getFeedAddToCollectionPopoverId, } from './helpers';
import { getIsLoggedIn } from '../../../publicSession/selectors';
import { restrictLoggedOut } from '../../../redux/loggedout';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { pushPopover } from '../../../Popovers/redux/actionCreators';
function handleCollectFave(_a) {
    var isLoggedIn;
    var _b = _a.payload, deviation = _b.deviation, notificationQueue = _b.notificationQueue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (notificationQueue !== getFeedNotificationQueue(deviation)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(pushPopover(getFeedAddToCollectionPopoverId(deviation), {
                    params: { ignorePreselectedCollections: true },
                }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default function feedViewSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(collectFave, handleCollectFave),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map